import React from 'react';
import { CustomModal, useCustomToast } from '../../../../components';
import TransfersDetailView from '../Views/TransfersDetailView';
import { Item, TransfersRequest } from '../../types/transfers-response';
import { useExportTransfer, useManageItemsTransfer, useManageTransfer, useVoucherTransfer } from '../../../../hooks';
import { useGoodStates } from '../../../../share';
import { useTransferManageValidator } from '../../../../utils/validators/transfer-request/transfer-manage-validator';
import ModalSaveChanges from '../../../../components/ModalSaveChanges/ModalSaveChanges';

interface TransfersDetailProps {
  isOpen: boolean;
  OnClose: () => void;
  data?: TransfersRequest;
  isLoading: boolean;
  isApproveRequest?: boolean;
  items?: Item[];
  isLoadingItems?: boolean;
}

const TransfersDetailContainer: React.FC<TransfersDetailProps> = ({
  isOpen,
  OnClose,
  data,
  isLoading,
  isApproveRequest,
  items,
  isLoadingItems,
}) => {

  const { data: goodStates } = useGoodStates();
  const [footerLeft, setFooterLeft] = React.useState<React.ReactNode>(null);
  const { mutateAsync } = useExportTransfer();
  const { mutateAsync: onVoucher } = useVoucherTransfer();
  const { showToast } = useCustomToast();
  const { mutateAsync: updateManageItems } = useManageItemsTransfer();
  const { mutateAsync: updateManage } = useManageTransfer();
  const [modalSignConfirmOpen, setModalSignConfirmOpen] = React.useState(false);
  const [signature, setSignature] = React.useState("");

  const manageTransfer = async ({ id, ...data }: { id: number, status_id: string, reason: string, signature_url: string }) => {
    try {
      await updateManage({ id, data });

      showToast('success', 'Solicitud de traslado ha sido actualizada.');
    } catch (error) {
      showToast('error', 'Error al actualizar la solicitud.');
    }
  };

  const manageItemsTransfer = async (data: { ids: number[], status_id: string, observations: string }) => {
    try {
      await updateManageItems({ data });

      showToast('success', 'Estado actualizado');
    } catch (error) {
      showToast('error', 'Error al actualizar estado.');
    }
  };

  const onSaveManageTransfer = (values: any) => {
    manageTransfer({ id: data?.id, signature_url: signature, ...values });
  }

  const formik = useTransferManageValidator({ onSubmit: onSaveManageTransfer });

  const handleSubmit = () => {
    if (formik.isValid && modalSignConfirmOpen) {
      formik.handleSubmit();
    }

    setModalSignConfirmOpen(!modalSignConfirmOpen);
  };

  return (
    <CustomModal
      title={`Detalle traslados entre funcionarios - ${data?.ticket || ''}`}
      labelSubmit={(data?.can_manage && isApproveRequest) ? "Guardar cambios" : undefined}
      onSave={handleSubmit}
      disabledBtn={!formik.isValid}
      open={isOpen}
      onCancel={OnClose}
      width="95vw"
      isLoading={isLoading}
      labelCancel='Finalizar'
      footerLeft={footerLeft}
    >
      <TransfersDetailView
        detailData={data}
        setFooterLeft={setFooterLeft}
        onDocuments={mutateAsync}
        onVoucher={onVoucher}
        manageItemsTransfer={manageItemsTransfer}
        goodStates={goodStates}
        formik={formik}
        isApproveRequest={isApproveRequest}
        dataItems={items}
        isLoadingItems={isLoadingItems || false}
      />
      <ModalSaveChanges
        title="Guardar cambios"
        textOne="¿Está seguro de gestionar esta solicitud de traslado?"
        textTwo="Una vez creado no podrá realizar cambios."
        open={modalSignConfirmOpen}
        width={900}
        isLoadingSave={false}
        onClose={() => setModalSignConfirmOpen(false)}
        haveFirma={true}
        labelSubmit="Aceptar"
        onSave={handleSubmit}
        handledDataFirma={setSignature} />
    </CustomModal>
  );
};

export default TransfersDetailContainer;
